import { Component, Input, OnInit } from '@angular/core';
import { BreadcrumbItem } from '../../models/inputModels';
import { Router } from '@angular/router';

@Component({
    selector: 'automatic-debit-breadcrumb',
    templateUrl: './automatic-debit-breadcrumb.component.html',
    styleUrls: ['./automatic-debit-breadcrumb.component.scss'],
})
export class AutomaticDebitBreadcrumbComponent implements OnInit {
    constructor(private router: Router) {}

    ngOnInit(): void {}
    @Input() items: BreadcrumbItem[] = [];

    navigateTo(route: string) {
        this.router.navigate([route]);
    }
}
